/** @format */

import {initializeApp} from 'firebase/app'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
import {getDatabase} from 'firebase/database'

const firebaseConfig={
  apiKey: 'AIzaSyD35B0-hAx5LbVLHZWM9erbSqOdxTtqM9g',
  authDomain: 'auth.flowsage.co',
  projectId: 'flowsage-web',
  storageBucket: 'flowsage-web.appspot.com',
  messagingSenderId: '92334233992',
  appId: '1:92334233992:web:e5bfa0c7ea868e09ff423d',
  measurementId: 'G-XCNPQSZVLT',
  databaseURL: 'https://flowsage-web-default-rtdb.firebaseio.com'
}

// Initialize Firebase app (always needed for Firestore/RTDB/Storage)
const app=initializeApp(firebaseConfig)
const db=getFirestore(app)
const rt=getDatabase(app)
const storage=getStorage(app)

// 6.2.5 — Auth is lazy-initialized on first access so the landing page
// doesn't pay the cost of loading the Firebase Auth SDK.
let _auth=null
function getAuthInstance() {
  if(!_auth) {
    // Dynamic import kept synchronous via the already-loaded firebase/auth bundle;
    // this just defers the SDK initialization until first call.
    const {getAuth}=require('firebase/auth')
    _auth=getAuth(app)
  }
  return _auth
}

// Named export that matches previous `auth` usage — callers get the same instance
// but initialization is deferred until the first actual use.
const auth={
  get currentUser() {return getAuthInstance().currentUser},
  onAuthStateChanged(...args) {return getAuthInstance().onAuthStateChanged(...args)},
  // Expose the raw Auth instance for SDK functions that need it directly
  getInstance() {return getAuthInstance()}
}

function getUser() {
  return getAuthInstance().currentUser
}

export {auth,getUser,getAuthInstance,db,storage,rt}
export default app
